const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

$(document).ready(function() {
// Swiper: Slider
    new Swiper('.prdslider', {
        loop: true,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        slidesPerView: 2,
        paginationClickable: true,
        spaceBetween: 20,
        speed:2000,
        autoplay:{
          delay:2000,
        },
        breakpoints: {
            1920: {
                slidesPerView: 4,
                spaceBetween: 15
            },
            1220: {
                slidesPerView: 4,
                spaceBetween: 30
            },
            1028: {
                slidesPerView: 3,
                spaceBetween: 30
            },
             991: {
                slidesPerView: 3,
                spaceBetween: 30
            },
             591: {
                slidesPerView: 3,
                spaceBetween: 30
            },
            480: {
                slidesPerView: 2,
                spaceBetween: 10
            }
        }
    });
});

